import { connect } from 'react-redux';
import * as R from 'ramda';
import { getCardsToDisplay } from '../../store/authorizationSequencingSlice';

import CardsList from './CardsList';

const mapState = R.applySpec({
  authorizationSequencingCards: getCardsToDisplay,
});

export default connect(mapState)(CardsList);
